import { ChevronDown } from "lucide-react";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface SelectProps extends Omit<React.ComponentProps<"select">, "value"> {
  value: string | number | undefined | null;
}

export function Select({ value = null, children, className, ...props }: SelectProps) {
  return (
    <div className="relative w-fit group">
      <select
        className={twMerge(
          clsx(
            "peer appearance-none w-full cursor-pointer",
            "rounded-md pl-3 pr-12 py-1.5 bg-transparent outline-offset-2",
            "group-hover:inset-ring-blue-500 group-hover:inset-ring-2 transition-all",
            "focus-visible:outline-2 focus-visible:outline-blue-500",
            {
              "inset-ring text-neutral-600 dark:text-neutral-400": value === null,
              "inset-ring-neutral-300 dark:inset-ring-neutral-700": value === null,
              "inset-ring-2 inset-ring-neutral-300 dark:inset-ring-neutral-700": value !== null,
            },
          ),
          className,
        )}
        value={value || ""}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        size={16}
        strokeWidth={3}
        className={clsx(
          "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none",
          "group-hover:stroke-blue-500",
          {
            "stroke-neutral-400 dark:stroke-neutral-500": true,
          },
        )}
      />
    </div>
  );
}

export function SelectLabel({ children, ...props }: React.ComponentProps<"label">) {
  return (
    <label className="mb-3 flex items-center font-semibold gap-x-2" {...props}>
      {children}
    </label>
  );
}
